exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.results[data-v-6336bccb]{\n    background: rgba(0, 0, 0, 0.50);\n    box-shadow: 0 11px 28px 0 rgba(0, 0, 0, 0.11);\n    -webkit-backdrop-filter: blur(80px);\n            backdrop-filter: blur(80px);\n    backface-visibility: hidden;\n    -webkit-font-smoothing: subpixel-antialiased;\n}\n.fadeHeight-enter-active[data-v-6336bccb], .fadeHeight-leave-active[data-v-6336bccb] {\n    transition: all 0.5s;\n    max-height: 1000px;\n}\n.fadeHeight-enter[data-v-6336bccb], .fadeHeight-leave-to[data-v-6336bccb]\n{\n    opacity: 0;\n    max-height: 0;\n}\n", ""]);

// exports
